import { StrictMode, useEffect } from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import "@uppy/core/css/style.min.css";
import "@uppy/dashboard/css/style.min.css";
import App from "@src/App";
import { ThemeProvider } from "top-brains-ui";

import { Provider, useDispatch } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "../src/app/store";
import { getEnvConfig } from "@src/utils/envUtils";
import { setGlobalState } from "@src/app/globalSlice";

if (typeof document !== "undefined") {
  document.body.classList.toggle("electron-app", getEnvConfig().type === "shell");
}

function BootstrapEnvironment() {
  const dispatch = useDispatch();

  useEffect(() => {
    const envConfig = getEnvConfig();
    const isElectronApp = envConfig.type === "shell";

    document.body.classList.toggle("electron-app", isElectronApp);
    dispatch(setGlobalState({ isElectronApp }));

    return () => {
      document.body.classList.remove("electron-app");
    };
  }, [dispatch]);

  return <App />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          <BootstrapEnvironment />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </StrictMode>
);
